import { FC, useEffect, useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { makeStyles } from "@material-ui/core";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import dayjs from "dayjs";

export const DateRangeSelector: FC<any> = ({ value, setValue }) => {  
  const classes = useStyles();
  useEffect(() => {
    const hideElement = () => {
      const popper = document.querySelector(".MuiPickersLayout-root");
      if (!popper) return;

      const elements = Array.from(popper.querySelectorAll("*"));
      const match = elements.find(
        (el: any) =>
          el.children.length === 0 && el.textContent.trim() === "MUI X Missing license key",
      );

      if (match) {
        const container: any = match || null;
        container.style.setProperty("display", "none", "important");
      }
    };

    const observer = new MutationObserver(() => {
      hideElement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    hideElement();

    return () => observer.disconnect();
  }, []);

  const pickerValue = useMemo(() => {
    return [value[0] ? dayjs(value[0]) : null, value[1] ? dayjs(value[1]) : null];
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        className={classes.root}
        value={pickerValue as any}
        onChange={(newValue) => {
          const [start, end] = newValue;
          const startStr = start && start.isValid() ? start.format("YYYY-MM-DD") : "";
          const endStr = end && end.isValid() ? end.format("YYYY-MM-DD") : "";
          setValue([startStr, endStr]);
        }}
        slotProps={{
          popper: {
            disablePortal: true,
          },
          dialog: {
            disablePortal: true,
          },
        }}
        slots={{ field: SingleInputDateRangeField }}
        desktopModeMediaQuery="none"
      />
    </LocalizationProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      paddingRight: 0,
    },
  },
}));
